import { observable, action, makeObservable } from 'mobx';
import { makePersistable } from 'mobx-persist-store';

export class WasteCalculatorStore {
  category: string = '';
  categoryMembersMap: Map<string, string[]> = new Map<string, string[]>();

  constructor() {
    makeObservable(this, {
      category: observable,
      setCategory: action,
      categoryMembersMap: observable,
      setCategoryMembersMap: action,
    });
    makePersistable(this, {
      name: 'WasteCalculatorStore',
      properties: [
        'category',
        'categoryMembersMap',
      ],
      storage: window.localStorage,
    });
  }

  setCategory(category: string) {
    this.category = category;
  }

  setCategoryMembersMap(categoryMembersMap: Map<string, string[]>) {
    this.categoryMembersMap = categoryMembersMap;
  }

  removeAllData() {
    this.category = '';
    this.categoryMembersMap = new Map<string, string[]>();
  }
}
export default WasteCalculatorStore;
